export default __webpack_public_path__ + "static/media/EmilyBao.c16830d0.jpg";